import * as yup from "yup";

export namespace allergyNS {
    export enum Severity {
        SEVERE = "SEVERE",
        MODERATE = "MODERATE",
        MILD = "MILD",
        UNKNOWN = "UNKNOWN",
    }

    export enum Status {
        ACTIVE = "ACTIVE",
        RESOLVED = "RESOLVED",
        UNKNOWN = "UNKNOWN",
    }
}

export const healthProfileAllergy = yup.object().shape({
    id: yup.number().nullable().positive().default(null),
    createdOnUnix: yup.number().nullable().positive().default(null),
    lastUpdatedOnUnix: yup.number().nullable().default(null),
    createdByDisplay: yup.string().nullable().default(null),
    createdById: yup.number().nullable().positive().default(null),
    lastUpdatedByDisplay: yup.string().nullable().default(null),
    lastUpdatedById: yup.number().nullable().positive().default(null),
    accountPatientId: yup.number().positive().required("Patient ID is required").default(-1),
    allergy: yup.string().min(1).max(100).required("Allergy is required").default(undefined),
    // Assuming this is automatically assigned by the system
    referenceId: yup
        .string()
        .min(1)
        .max(100)
        .required("Reference ID is required")
        .default(undefined),
    mainReaction: yup.string().max(100).nullable().default(null),
    severity: yup
        .mixed<allergyNS.Severity>()
        .oneOf(Object.values(allergyNS.Severity))
        .required("Severity is required")
        .default(allergyNS.Severity.UNKNOWN),
    status: yup
        .mixed<allergyNS.Status>()
        .oneOf(Object.values(allergyNS.Status))
        .required("Status is required")
        .default(allergyNS.Status.UNKNOWN),
    onsetDate: yup
        .string()
        .nullable()
        .transform((value: string) => (value === "" ? null : value))
        .default(null),
    endDate: yup
        .string()
        .nullable()
        .transform((value: string) => (value === "" ? null : value))
        .default(null),
    comment: yup.string().max(400).nullable().default(null),
    active: yup.boolean().required().default(true),
});

export type Allergy = yup.InferType<typeof healthProfileAllergy>;

export enum RecordType {
    ALLERGY = "ALLERGY",
    MEDICATION = "MEDICATION",
    PROBLEM = "PROBLEM",
}

export enum KnownStatus {
    REPORTED = "REPORTED",
    UNKNOWN = "UNKNOWN",
    NO_KNOWN = "NO_KNOWN",
}

export interface AllergyProfile {
    allergies: Allergy[];
    allergyKnownStatus: KnownStatus;
    patientFullName: string;
}
